// KYT Yapı Teknolojileri — corporate content (English). Mirrors src/data/site.js.
// Shared constants (company, sectionHeroes) are imported from site.js.

export { company, sectionHeroes } from "@/data/site";

export const stats = [
  { value: "1993", label: "Founded", suffix: "", static: true },
  { value: "30", label: "Years of Experience", suffix: "+" },
  { value: "42", label: "Completed Projects", suffix: "+" },
  { value: "100", label: "Million $ Volume", suffix: "M+" },
];

export const vision = {
  title: "Our Vision",
  text: "To be among the pioneering companies in engineering, consultancy, contracting and sales within the electrical sector in Turkey and worldwide.",
  extra:
    "You work with a warm, sincere team backed by many years of experience — people who love their work, who keep increasing the number of projects we are proud of, and who make you smile at every stage. Not earning money, but earning customers and friends, is our most important philosophy.",
};

export const mission = {
  title: "Our Mission",
  items: [
    "To enable entrepreneurs to use electrical energy efficiently and safely.",
    "To complete every kind of electrical contracting work on time — even ahead of schedule — without any problems.",
    "To build energy distribution systems that last for years with our expert team.",
  ],
};

export const activityAreas = {
  title: "Our Activity Areas",
  intro:
    "Without ever compromising on established standards, we serve with our expert technical staff and a conscientious sense of responsibility. We always embrace progress as a core principle by adapting to emerging technological innovations, research and training.",
  items: [
    "Electrical Planning, Design & Contracting",
    "Infrastructure Applications",
    "Cabling & Termination",
    "Testing & Automation Services",
    "Electrical Materials Sales",
  ],
};

export const services = {
  title: "Electrical Contracting and Project Services",
  titleEn: "Electrical Contracting and Project Services",
  intro:
    "We provide end-to-end solutions in electrical and engineering work, from consultancy to commissioning.",
  items: [
    "Consultancy, Planning & Installation",
    "Modernization & Commissioning Services",
    "Design and implementation of electrical, instrumentation and electromechanical installations in industrial facilities",
    "Electrical Distribution & Control Panels",
    "MV Power Transmission Lines & Transformer Substations — Design and Implementation",
    "Compensation Systems",
    "Lighting Systems",
    "Earthing & Lightning Protection Systems",
    "Electrical Fault Detection, Maintenance & Repair",
    "Security Systems",
    "Perimeter Security Automation",
    "CCTV Automation",
    "Access Control Systems",
    "Building Automation Systems",
    "Fire Alarm Systems",
    "Monitoring & Distribution Systems",
  ],
};

export const certificates = [
  {
    code: "ISO 9001:2015",
    name: "Quality Management System",
    desc: "Quality management standard for design, engineering and contracting works.",
  },
  {
    code: "ISO 14001:2015",
    name: "Environmental Management System",
    desc: "Environmental responsibility standard for construction, engineering and contracting works.",
  },
  {
    code: "OHSAS 18001:2007",
    name: "Occupational Health & Safety Management System",
    desc: "International standard for occupational health and safety management.",
  },
];

export const categories = [
  { slug: "all", name: "All Projects" },
  { slug: "saglik", name: "Healthcare Facilities" },
  { slug: "stadyum", name: "Stadiums & Sports" },
  { slug: "avm", name: "Shopping Centers" },
  { slug: "endustriyel", name: "Industrial Facilities" },
  { slug: "sosyal", name: "Social & Administrative Buildings" },
  { slug: "egitim", name: "Educational Buildings" },
  { slug: "turizm", name: "Tourism Facilities" },
  { slug: "konut", name: "Residences" },
];

export const categoryName = (slug) =>
  (categories.find((c) => c.slug === slug) || {}).name || slug;

// Additional references listed in the catalogue without a dedicated gallery.
export const references = [
  { name: "Ege Yatırım", loc: "Istanbul" },
  { name: "Rotary Çocuk Evi", loc: "Istanbul" },
  { name: "İgsaş Güney San. A.Ş.", loc: "Kocaeli" },
  { name: "İktisat Bankası", loc: "Nationwide" },
  { name: "Kordsa", loc: "Kocaeli" },
  { name: "Şener Arda İnşaat İş Ortaklığı", loc: "Kocaeli" },
  { name: "Karpet Ltd. Şti.", loc: "Kocaeli" },
  { name: "Emlak Bank", loc: "Adapazarı" },
  { name: "Shell", loc: "Yalova" },
  { name: "Erenkaya İnşaat", loc: "Kocaeli" },
  { name: "Marmara Transport Gemi San. A.Ş.", loc: "Kocaeli" },
  { name: "Karşıyaka Sağlık Ocağı", loc: "Kocaeli" },
  { name: "Kentsa Sağlık Evi", loc: "Kocaeli" },
  { name: "Özel Kocaeli Kampüsü", loc: "Kocaeli" },
  { name: "Riva Konakları Koop.", loc: "Istanbul" },
  { name: "Şile Evleri Yapı Koop.", loc: "Istanbul" },
  { name: "Akbahçe Evleri", loc: "Yalova" },
  { name: "Akbahçe Birlik Yapı Koop.", loc: "Istanbul" },
  { name: "Onurcan Yapı Koop.", loc: "Kocaeli" },
  { name: "Kentsa A.Ş.", loc: "Kocaeli" },
  { name: "Değirmendere Belediyesi", loc: "Kocaeli" },
  { name: "Anadolu Yapı Ltd. Şti.", loc: "Kocaeli" },
  { name: "Kafkas İnşaat Ltd. Şti.", loc: "Kocaeli" },
  { name: "S.S. Rüyam Kartepe Koop.", loc: "Muğla" },
  { name: "Alarko A.Ş.", loc: "Istanbul" },
  { name: "Tekfen İnşaat A.Ş.", loc: "Istanbul" },
  { name: "Bahçekent Villaları", loc: "Kocaeli" },
];
